import{jsxs as i,jsx as r}from"react/jsx-runtime";import t from"styled-components";import a from"./EuFlagIcon.js";const s=t.div`
  display: grid;
  grid-template: 100% / 16px auto;
  width: 124px;
  height: 32px;
`,n=t.div`
  display: grid;
  grid-template: 55% 45% / 100%;
  justify-items: center;
  background-color: #0357d3;
  border: 1.5px solid ${({theme:e})=>e.colors.text.dark};
  border-right: none;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;

  svg {
    font-size: 11px;
    align-self: center;
  }
`,p=t.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({theme:e})=>e.colors.background.light};
  color: ${({theme:e})=>e.colors.text.dark};
  font-family: ${({theme:e})=>e.typography.fontBaseFamily};
  font-size: 20px;
  font-weight: ${({theme:e})=>e.typography.fontBaseBoldWeight};
  border: 1.5px solid ${({theme:e})=>e.colors.text.dark};
  border-left: none;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
`,h=t.div`
  color: ${({theme:e})=>e.colors.text.light};
  font-family: ${({theme:e})=>e.typography.fontBaseFamily};
  font-size: 10px;
  font-weight: ${({theme:e})=>e.typography.fontBaseBoldWeight};
  line-height: 1;
`,c=({regNumber:e})=>{const d=l=>{const o=l.replace(/\s+/g,"").slice(0,6);return`${o.slice(0,3)} ${o.slice(3)}`};return i(s,{role:"text","aria-label":`Registration plate: ${e}`,children:[i(n,{"aria-hidden":"true",children:[r(a,{"aria-hidden":"true"}),r(h,{children:"S"})]}),r(p,{children:d(e)})]})};export{c as default};
